import { useEffect, useState } from "react"
import { useCustomQuery } from "./useCustomQuery"

const useAttribute = () => {
  const [attributes, setAttributes] = useState([])
  const {
    data: attributeResponse,
    isLoading,
    isError,
    isFetching,
  } = useCustomQuery(["settings"], "settings?filter[key]=attribute")

  useEffect(() => {
    if (attributeResponse?.data) {
      setAttributes(attributeResponse.data)
    }
  }, [attributeResponse])

  return {
    attributes,
    isLoading,
    isError,
    isFetching,
    setAttributes,
  }
}

export default useAttribute
